export default __webpack_public_path__ + "static/RunRight7-9f0d159752ed0eb8436b9c4dc3efda93.mp3";